



























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Time from '@shared/components/forms/inputs/time/time.vue';
import ButtonGroup from '@shared/components/forms/inputs/button-group/button-group.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import { BookingOrganizationForm } from '@bookings/interfaces/booking';
import { BookingFields } from '@/config/bookings';
import { setProp } from '@shared/helpers/operators';
import { Period } from '@centers/interfaces/period';

@Component({
  components: {
    BpcFormProvider,
    'bpc-datepicker': Datepicker,
    'bpc-time': Time,
    'bpc-button-group': ButtonGroup,
    'bpc-switch': Switch,
    'bpc-input': Input,
    'bpc-textarea': Textarea,
    'bpc-select': Select,
    'bpc-entity-select': EntitySelect,
  },
})
export default class PublicOrganizationBookingCustomForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    selectPeriod: InstanceType<typeof EntitySelect> & { items: Period[] };
  };
  @Prop(Number) readonly modelId: number;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly value: Partial<BookingOrganizationForm>;

  @Prop({
    type: Object,
    default() {
      return {};
    },
  })
  readonly errorsObject;

  get formModel(): Partial<BookingOrganizationForm> {
    return this.value;
  }

  set formModel(value) {
    this.$emit('input', value);
  }

  get fieldsConfig(): typeof BookingFields {
    return BookingFields;
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  onChangeResource(resource: number[]) {
    setProp(this.formModel, 'resource_id', resource[0]);
  }

  onChangePeriod(id: number) {
    const period: Period = this.$refs.selectPeriod?.items?.find((item: Period) => item.id == id);
    if (period) {
      setProp(this.formModel, 'start_date', period.start_date);
      setProp(this.formModel, 'end_date', period.end_date);
    }
  }
}
